import { restApiMP } from "@plannel/services/utils/rest-api";

const getInventory = params => {
  return restApiMP.get("/api/run-mp/inventory", { params });
};

const run = data => {
  return restApiMP.post("/api/run-mp", data);
};

const simulation = data => {
  return restApiMP.post("/api/run-mp/simulation", data);
};

const runMpService = {
  getInventory,
  run,
  simulation
};

export default runMpService;